import React from 'react';

import { FormBase } from '../Interface';
import { BuildingPage } from './BuildingPage';
import { useBuilding } from '../../hooks/useBuilding';
import BuildingReports from './BuildingReports';

export const BuildingMain = () => {
  const buildingState = useBuilding();

  return (
    <FormBase
      name="Building"
      leftPanelContent={<BuildingPage buildingState={buildingState} />}
      rightPanelContent={<> {!buildingState.isLoading && <BuildingReports buildingState={buildingState} />}</>}
    />
  );
};
